import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActionsTorchOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.609 3.258 1.35 0 0 1.35l3.08 3.081a5.137 5.137 0 0 0-1.309 3.433c0 1.601.73 3.032 1.875 3.978v3.053h6.562v-3.053l.152-.131 3.27 3.27 1.35-1.351-3.447-3.447-1.443-1.444L6.052 4.7 4.609 3.258zm-.963 4.606c0-.8.287-1.534.763-2.104l4.622 4.622a3.284 3.284 0 0 1-.698.447v2.19H5.52v-2.19a3.281 3.281 0 0 1-1.875-2.965z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m6.42 2.733 2.625 2.625c.14.119.27.248.388.388l2.625 2.626A5.156 5.156 0 0 0 6.42 2.733z",
		fill: "currentColor"
	})]
});
export default SvgActionsTorchOff;
